import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { profileSlice } from "redux/features/profile";
import { Message, Box, Content } from "react-bulma-components";
import { dualSort, caseInsensitive, ascending, descending } from "util/sort";
import ActivityDates from "./dates";
import IconButton from "util/iconButton";
import { FaEdit } from "react-icons/fa";
import MathContent from "util/mathjax";

function ParticipationSummary({ participationSummary, forPast }) {
  const { activity, attending, is_past } = participationSummary;
  const otherRoles = [
    "organizer",
    "speaker",
    "cancelled",
    "declined",
    "on waiting list",
  ].filter((r) => participationSummary.roles[r]);
  const navigate = useNavigate();
  return (
    <Box>
      <ActivityDates activity={activity} />
      <MathContent>{participationSummary.activity_title}</MathContent>
      {otherRoles.length > 0 ? (
        <div className="roles">
          Status: {otherRoles.join(", ")}.
          {attending === null ? (
            <span className="unconfirmed-attendee">
              {" "}
              Not registered; please confirm attendance.
            </span>
          ) : attending ||
            participationSummary.roles["on waiting list"] ? null : (
            <span className="not-attending">
              {is_past ? " Did not attend." : " Not attending."}
            </span>
          )}
        </div>
      ) : null}
      <div className="buttons">
        <IconButton
          icon={FaEdit}
          onClick={(e) => navigate("participation/" + activity.id)}
        >
          Details
        </IconButton>
      </div>
    </Box>
  );
}

export function ParticipationList({ forPast }) {
  const { data } = useSelector(profileSlice.selector);

  const participationSummaries = data.participations
    .map((p) => {
      // Bring "activity" properties up to the top level for sorting
      const { start_date, end_date, title: activity_title } = p.activity;
      return { start_date, end_date, activity_title, ...p };
    })
    .filter((p) => p.show && (forPast ? p.is_past : !p.is_past))
    .sort(
      dualSort(
        "start_date",
        caseInsensitive,
        forPast ? descending : ascending,
        "activity_title",
        caseInsensitive,
        ascending
      )
    );

  return (
    <Message>
      <Message.Header>
        {forPast ? "Past" : "Current/Upcoming"} Activity Registrations
      </Message.Header>
      <Message.Body className="scrollable">
        {forPast ? (
          <Content textAlign="center">
            <Link to="participations/">
              <i>View all by year</i>
            </Link>
          </Content>
        ) : null}
        {participationSummaries.map((p) => (
          <ParticipationSummary
            key={p.id}
            participationSummary={p}
            forPast={forPast}
          />
        ))}
      </Message.Body>
    </Message>
  );
}
